"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "InternalLinkPreviewContext", {
    enumerable: true,
    get: function() {
        return InternalLinkPreviewContext;
    }
});
function _react() {
    const data = require("react");
    _react = function() {
        return data;
    };
    return data;
}
const InternalLinkPreviewContext = (0, _react().createContext)(undefined);

//# sourceMappingURL=InternalLinkPreviewContext.js.map
